import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import { userDataFromLocal } from '../utils/getUserDetails';
import DialogMsg from '../../global/DialogMsg';

import {
  VERSION,
  createClient,
  createCameraVideoTrack,
  createMicrophoneAudioTrack,
  onCameraChanged,
  onMicrophoneChanged,
  notAvailable
} from 'agora-rtc-sdk-ng';
import {
  Cameraswitch,
  Close,
  Phone,
  PhoneDisabled,
  Videocam,
  VideocamOff,
  VolumeMute,
  VolumeOff
} from '@mui/icons-material';
import LoaderDynamicMsg from '../../global/LoaderDynamicMsg';
import { useTranslation } from 'react-i18next';

const appID = process.env.REACT_APP_VIDEO_APP_ID;

let audioTrack;
let videoTrack;

const { GenerateTokenForEKYC, GetKYCStatus } = onBoardingEkycServices;

const VideoKYC = () => {
  // const [localStreams, setLocalStreams] = useState({
  //   camera: {
  //     id: '',
  //     stream: {}
  //   },
  //   screen: {
  //     id: '',
  //     stream: {}
  //   }
  // });

  // console.log('IslocalStreams', localStreams);

  // const [cameraVideoProfile] = useState('480P_4');
  // const [remoteStreams, setRemoteStreams] = useState([]);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [ifCheck, setIfCheck] = useState(false);
  const [CheckError, setCheckError] = useState(false);
  const [newMsgType, setMsgType] = useState('');
  const [dialogMsg, setDialogMsg] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [videoStart, setVideoStart] = useState(false);
  const [mainStreamId, setMainStreamId] = useState(true);
  const [updateMuteStatusUI, setUpdateMuteStatusUI] = useState(true);
  const [vkycStatus, setVkycStatus] = useState(null);
  const [openDialogThanks, setOpenDialogThanks] = useState(false);

  const [isAudioOn, setIsAudioOn] = useState(false);
  const [isVideoOn, setIsVideoOn] = useState(false);
  // const [isAudioPubed, setIsAudioPubed] = useState(false);
  // const [isVideoPubed, setIsVideoPubed] = useState(false);
  const [isVideoSubed, setIsVideoSubed] = useState(false);
  const [camerFacingMode, setCameraFacingMode] = useState(
    window.screen.width < 900 ? 'user' : 'environment'
  );
  // console.log('camerFacingMode', camerFacingMode);
  // console.log('videoStart', videoStart);

  // const [isJoined, setIsJoined] = useState(false);

  // Creating an AgoraRTC client with specified mode and codec
  const agoraClient = createClient({
    mode: 'rtc',
    // mode: 'live',
    codec: 'vp8',
    role: 'audience'
  });

  const localStorageLangKey = localStorage.getItem('i18nextLng');
  const selectedLang = localStorageLangKey ? localStorageLangKey : '';

  const listItemTerms = {
    en: [
      ' Ensure that only you are in the camera frame.',
      ' Ensure that your face is well lit.',
      ' Ensure that there are no bright lights behind you',
      ' Keep your documents handy',
      ' We will try to access your current location.',
      ' Our agent will capture your picture if required.',
      ' Do not attend call or open any audio/video camera applications in between the video call',
      ' Be ready with pen and blank white paper for signature.'
    ],
    hi: [
      'सुनिश्चित करें कि कैमरे के फ्रेम में केवल आप ही हों।',
      'सुनिश्चित करें कि आपका चेहरा अच्छी तरह से रोशन हो।',
      'सुनिश्चित करें कि आपके पीछे कोई तेज़ रोशनी न हो',
      'अपने दस्तावेज़ संभाल कर रखें',
      'हम आपके वर्तमान स्थान तक पहुँचने का प्रयास करेंगे।',
      'जरूरत पड़ने पर हमारा एजेंट आपकी तस्वीर खींच लेगा।',
      'कॉल अटेंड न करें या वीडियो कॉल के बीच में कोई ऑडियो/वीडियो कैमरा एप्लिकेशन न खोलें',
      'हस्ताक्षर के लिए कलम और कोरे सफेद कागज के साथ तैयार रहें।'
    ],
    gj: [
      'ખાતરી કરો કે કેમેરા ફ્રેમમાં ફક્ત તમે જ છો.',
      'તમારો ચહેરો સારી રીતે પ્રકાશિત છે તેની ખાતરી કરો.',
      ' ખાતરી કરો કે તમારી પાછળ કોઈ તેજસ્વી લાઇટ ન હોય',
      'તમારા દસ્તાવેજો હાથમાં રાખો',
      'અમે તમારા વર્તમાન સ્થાનને ઍક્સેસ કરવાનો પ્રયાસ કરીશું.',
      ' જો જરૂરી હોય તો અમારો એજન્ટ તમારી તસવીર કેપ્ચર કરશે.',
      'કોલમાં હાજરી આપશો નહીં અથવા વીડિયો કૉલની વચ્ચે કોઈપણ ઑડિયો/વિડિયો કૅમેરા એપ્લિકેશન ખોલશો નહીં',
      ' સહી માટે પેન અને કોરા સફેદ કાગળ સાથે તૈયાર રહો.'
    ]
  };

  const leaveChannel = async (audioTrack, videoTrack) => {
    await agoraClient.leave();

    await videoTrack.setEnabled(false);
    await audioTrack.setEnabled(false);

    setIsVideoOn(false);
    setVideoStart(false);
    // setIsJoined(false);
    // setIsAudioPubed(false);
    // setIsVideoPubed(false);
    return true;
  };

  // handleGenerateTokenApi API
  const handleGenerateTokenApi = async () => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();

      const headerCredential = {
        // application_no: userData?.applicationNo
        applicationNo: userData?.applicationNo
      };

      const GenerateTokenResponse = await GenerateTokenForEKYC(headerCredential);
      if (GenerateTokenResponse.status === 'Success') {
        setVideoStart(true);
        localStorage.setItem('callToken', GenerateTokenResponse?.data?.token);
        localStorage.setItem('channel', GenerateTokenResponse?.data?.channel);
        navigate(
          `/in/video-kyc?t=${GenerateTokenResponse?.data?.token}&c=${GenerateTokenResponse?.data?.channel}`
        );
        startAcall(
          GenerateTokenResponse?.data?.token,
          GenerateTokenResponse?.data?.channel,
          camerFacingMode
        );
        // initFCM();
      } else if (GenerateTokenResponse.status === 'Failed') {
        setOpenDialogeMsg(true);
        setDialogMsg(GenerateTokenResponse.message);
      } else {
        setOpenDialogeMsg(true);
        setDialogMsg(t('Something went wrong'));
      }
    } catch (error) {
      console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };

  // Msg Dialog close handler
  const closeDialogMsgHandler = async (e) => {
    console.log('newMsgType', newMsgType);
    if (newMsgType === 'AGENTBUSY') {
      // GetKYCStatusApi();
    } else {
      setOpenDialogeMsg(false);
      setDialogMsg('');
    }
  };

  // GetKYCStatus API
  const GetKYCStatusApi = async () => {
    try {
      setOpenloader(true);
      const userData = userDataFromLocal();
      const hdrCredential = {
        applicationNo: userData?.applicationNo,
        kycType: 'FRESH_KYC', // hardcode from backend side as discussed with jeetu
        mobileNo: userData?.mobileNumber
      };
      const GetKYCStatusResponse = await GetKYCStatus(hdrCredential);
      if (GetKYCStatusResponse.status === 'SUCCESS') {
        setVkycStatus(GetKYCStatusResponse.data);
        // console.log('useruseruseruser', GetKYCStatusResponse.data);
        if (
          GetKYCStatusResponse.data?.KYC_STATUS === 'COMPLETED' &&
          GetKYCStatusResponse.data?.VKYC_STATUS === 'COMPLETED'
        ) {
          setOpenDialogThanks(true); // Thank you dialog open when kyc and vkyc status completed to user view
          setOpenloader(false);
        } else {
          setOpenDialogThanks(true); // If not done vKYC
          setOpenloader(false);
        }
      } else if (GetKYCStatusResponse.status === 'error' || GetKYCStatusResponse.status === 500) {
        setDialogMsg(
          GetKYCStatusResponse.error !== undefined
            ? GetKYCStatusResponse.error
            : t('Something went wrong')
        );
        setOpenDialogeMsg(true);
      } else {
        setDialogMsg(
          GetKYCStatusResponse.error !== undefined
            ? GetKYCStatusResponse.error
            : t('Something went wrong')
        );
        setOpenDialogeMsg(true);
      }
    } catch (error) {
      // console.log('errorerror', error);
    } finally {
      setOpenloader(false);
    }
  };
  // GetKYCStatus API end

  const muteMicrophone = async () => {
    await audioTrack.setEnabled(!updateMuteStatusUI);
    setUpdateMuteStatusUI(!updateMuteStatusUI);
  };

  const showHideVide = async () => {
    await videoTrack.setEnabled(!mainStreamId);
    setMainStreamId(!mainStreamId);
  };

  const toggleCameraFacing = async () => {
    await videoTrack.setEnabled(!mainStreamId);
    // setMainStreamId(!mainStreamId);

    const callToken = localStorage.getItem('callToken');
    const channel = localStorage.getItem('channel');
    console.log('isUnsubscribe', agoraClient);
    const usermode = camerFacingMode === 'user' ? 'environment' : 'user';
    setCameraFacingMode(usermode);

    // startAcall(callToken, channel, usermode);
    await turnOnCamera(true, videoTrack, usermode);
    // agoraClient.on('user-published', onUserPublish);

    await agoraClient.join(appID, channel, callToken || null, null);

    await agoraClient.publish(videoTrack);
    // await agoraClient.publish(audioTrack);

    // await joinChannel(callToken, channel, appID, usermode);
  };

  const turnOnCamera = async (flag, vd, usermode) => {
    console.log('checkpoint 6', usermode);
    flag = flag ?? !isVideoOn;
    setIsVideoOn(flag);
    videoTrack = await createCameraVideoTrack({ facingMode: usermode });
    console.log('checkpoint 11', videoTrack);
    videoTrack.play('camera-video');

    console.log('checkpoint 7');
  };

  const turnOnMicrophone = async (flag) => {
    flag = flag ?? !isAudioOn;
    setIsAudioOn(flag);

    if (audioTrack) {
      return audioTrack.setEnabled(flag);
    }

    audioTrack = await createMicrophoneAudioTrack();
    // audioTrack.play();
  };
  // Define the joinChannel function
  const joinChannel = async (token, channelName, appID, usermode) => {
    console.log('checkpoint 2');
    await turnOnCamera(true, videoTrack, usermode);
    await turnOnMicrophone(true);
    agoraClient.on('user-published', onUserPublish);
    agoraClient.on('user-unpublished', handleUserUnpublished);
    console.log('checkpoint 3');

    await agoraClient.join(appID, channelName, token || null, null);
    console.log('checkpoint 4');

    await agoraClient.publish(videoTrack);
    await agoraClient.publish(audioTrack);
    console.log('checkpoint 5', isVideoSubed);
  };
  const onUserPublish = async (user, mediaType) => {
    console.log('checkpoint 8', user, mediaType);
    if (mediaType === 'video') {
      const remoteTrack = await agoraClient.subscribe(user, mediaType);
      console.log('checkpoint 9', user, mediaType);
      remoteTrack.play('remote-video');
      setIsVideoSubed(true);
    }
    if (mediaType === 'audio') {
      const remoteTrack = await agoraClient.subscribe(user, mediaType);
      console.log('checkpoint 10', user, mediaType);
      remoteTrack.play();
    }
  };
  const handleUserUnpublished = async (user, mediaType) => {
    if (mediaType === 'video') {
      // await GetKYCStatusApi();
      setOpenloader(true);
      setTimeout(() => {
        GetKYCStatusApi();
        setOpenloader(false);
      }, 2000);
      // when disconnect from admin show dialog and redirect at schedule again
      setOpenDialogeMsg(true);
      setDialogMsg('Call ended! Thank you');
      // setMsgType('AGENTBUSY');
      setTimeout(() => {
        setOpenDialogeMsg(false);
        setDialogMsg('');
        leaveChannel();
      }, 3000);
    }
    console.log('useruseruseruser', user, mediaType);
    // setOpenDialogeMsg(true);
    // setDialogMsg('Call ended! Thank you');
    // setMsgType('AGENTBUSY');
    // setTimeout(() => {
    //   setOpenDialogeMsg(false);
    //   setDialogMsg('');
    //   leaveChannel();
    // }, 3000);
  };
  const startAcall = async (token, channelName, usermode) => {
    console.log('is all set appId', appID);
    console.log('is all set token', token);
    console.log('is all set channelName', channelName);

    try {
      // Checking if both token and channelName are present
      if (token && channelName && appID) {
        console.log('checkpoint 1');
        // Joining the channel after the client is initialized successfully
        joinChannel(token, channelName, appID, usermode);
      }
    } catch (e) {
      // Handle any exceptions that may occur during the execution
    }
    // token, channelName, userID
  };

  // useEffect(() => {
  //   const startCallIfPossible = async () => {
  //     const callToken = localStorage.getItem('callToken');
  //     const callChannel = localStorage.getItem('channel');

  //     if (callToken && callChannel) {
  //       await startAcall(callToken, callChannel);
  //       // Set up event listener once call is started
  //       // agoraClient.on('user-published', onUserPublish);
  //     }
  //   };

  //   startCallIfPossible();
  //   // Clean up event listener when component unmounts or when the effect runs again
  //   return () => {
  //     agoraClient.off('user-published', onUserPublish);
  //   };
  // }, []);

  // useEffect(() => {
  //   // Code to run when the component mounts
  //   if (videoStart === true) {
  //     // console.log('checkpoint 5-2', isVideoSubed);
  //     // // Setting up a timeout with a delay of 2000 milliseconds (2 seconds)
  //     // const timeoutId = setTimeout(() => {
  //     //   console.log('checkpoint 5-2', isVideoSubed);
  //     //   if (isVideoSubed === false) {
  //     //     setOpenDialogeMsg(true);
  //     //     setDialogMsg(
  //     //       'All our Agents are busy right now Kindly schedule a new slot for vkyc from the main menu'
  //     //     );
  //     //     setMsgType('AGENTBUSY');
  //     //   }
  //     // }, 20000);
  //     // // Clean up the timeout when the component unmounts or when the dependency changes
  //     // return () => clearTimeout(timeoutId);
  //   }
  // }, [isVideoSubed, videoStart]);

  return (
    <>
      {/* <Loader openloader={openloader} /> */}
      <LoaderDynamicMsg openloader={openloader} LoaderMsg="Please wait for confirmation" />
      <PageHeading pageTitle="Video KYC Instructions" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        {videoStart ? (
          <Box className="vdoKyc">
            <Grid container spacing={{ xs: 1, sm: 4, md: 5 }} mb={3}>
              <Grid item xs={12} sm={12} md={6}>
                <Typography className="hideMobile" variant="subtitle1" mb={1} textAlign="center">
                  {t('Client Video')}
                </Typography>
                <div
                  className="localVideoHolder"
                  // style={{ width: 580, height: 420 }}
                  id="local-video"
                  width="100%"
                >
                  <video className="vdoSize" id="camera-video"></video>
                  {isVideoOn ? '' : <span class="loader"></span>}
                </div>
              </Grid>
              {/* <Divider
                className="devider"
                orientation="vertical"
                flexItem
                style={{ marginRight: '-20px' }}
              /> */}
              <Grid item xs={12} sm={12} md={6}>
                <Typography className="hideMobile" variant="subtitle1" mb={1} textAlign="center">
                  {t('Bank admin Video')}
                </Typography>

                <div
                  className="agentVideoHolder"
                  // style={{ width: 580, height: 420 }}
                  id="remote-streams"
                  width="100%"
                >
                  <video className="vdoSize" id="remote-video"></video>

                  {isVideoSubed ? '' : <span class="loader"></span>}
                </div>
              </Grid>
            </Grid>
            <Box display="flex" justifyContent="center">
              <ButtonGroup
                className="mobileButtons"
                variant="outlined"
                aria-label="loading button group"
                orientation="vertical"
                size="small"
              >
                {/* <Tooltip title="End call" placement="top" arrow> not require end call as per client feedback
                  <Button
                    onClick={() => {
                      leaveChannel(audioTrack, videoTrack);
                    }}
                  >
                    <PhoneDisabled />
                  </Button>
                </Tooltip> */}
                <Button onClick={muteMicrophone}>
                  {updateMuteStatusUI ? (
                    <Tooltip title={`${t('Volume')} ${t('mute')}`} placement="top" arrow>
                      <VolumeMute />
                    </Tooltip>
                  ) : (
                    <Tooltip title={`${t('Volume')} ${t('on')}`} placement="top" arrow>
                      <VolumeOff />
                    </Tooltip>
                  )}
                </Button>
                <Button onClick={showHideVide}>
                  {mainStreamId ? (
                    <Tooltip title={`${t('Video')} ${t('off')}`} placement="top" arrow>
                      <Videocam />
                    </Tooltip>
                  ) : (
                    <Tooltip title={`${t('Video')} ${t('on')}`} placement="top" arrow>
                      <VideocamOff />
                    </Tooltip>
                  )}
                </Button>
                <Tooltip title="Camera switch" placement="top" arrow>
                  <Button className="switchForMobileIcon" onClick={toggleCameraFacing}>
                    <Cameraswitch />
                  </Button>
                </Tooltip>
              </ButtonGroup>
            </Box>
          </Box>
        ) : (
          <Box>
            <Box className="imagePreviewBox" textAlign="center">
              <img
                className="imagePreviewFrame"
                src="/static/videoKYC.png"
                alt="Document Preview"
              />
            </Box>
            {/* <Box mb={3}>
              <Typography variant="h6">Live video call</Typography>
              <Typography>
                Your KYC verification call will take less than 3 minutes to complete, keep you
                document on hand.
              </Typography>
            </Box> */}

            <Box mb={2} className="vScrollbar vdoKycVScroll">
              <List className="ListOuter" component="ol">
                {listItemTerms[selectedLang].map((item, index) => (
                  <ListItemText
                    primary={`${index + 1}.${item}`}
                    disablePadding
                    className="listItem"
                    key={index}
                  />
                ))}
              </List>
              <Typography variant="body2" style={{ fontSize: '11px', fontWeight: 'bold' }}>
                {t(
                  'Please Note Complete session will be recorded as per our internal policies for quality assurance and training purpose'
                )}
              </Typography>
            </Box>

            <Box mb={2}>
              <FormControlLabel
                className="checkboxAccept"
                style={{ fontSize: '11px' }}
                control={
                  <Checkbox
                    size="small"
                    sx={{ color: '#3C3C4B', '&.Mui-checked': { color: '#03989a    ' } }}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setIfCheck(true);
                        setCheckError(false);
                      } else {
                        setIfCheck(false);
                      }
                    }}
                  />
                }
                label={t(
                  'I have read all the clause above and I agree to all terms and conditions raised by Upwards to perform my VKyc'
                )}
              />
              {CheckError && (
                <Typography variant="body2" sx={{ color: 'red', fontSize: '12px' }}>
                  {t('Please accept terms and conditions')}
                </Typography>
              )}
            </Box>

            <Box Container justifyContent="center" alignItems="center" textAlign="center">
              {/* <Button onClick={handleGenerateTokenApi} className="mainBtn btnLink"> */}
              <Button
                onClick={(e) => {
                  if (ifCheck === true) {
                    handleGenerateTokenApi();
                  } else {
                    setCheckError(true);
                    return '';
                  }
                }}
                className="mainBtn"
              >
                {t('Start video KYC call')}
              </Button>
            </Box>
          </Box>
        )}

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Message"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
        {/* Thank you msg when VKY has been completed */}
        <Dialog
          fullWidth
          maxWidth="sm"
          open={openDialogThanks}
          onClose={() => setOpenDialogThanks(false)}
          className="alertDialogWrap"
        >
          <DialogTitle className="dialog-title" style={{ textAlign: 'center' }}>
            <Typography variant="subtitle1">{t('Message')}</Typography>

            <IconButton
              // onClick={() => setOpenDialogThanks(false)}
              onClick={() => {
                leaveChannel(audioTrack, videoTrack); // leave all input audio and video when leave
                setOpenDialogThanks(false); // dialog false
                setOpenloader(true);
                setTimeout(() => {
                  navigate('/in/selfregistration'); // redirect at home page
                  setOpenloader(false);
                }, 500);
              }}
              size="small"
              style={{ position: 'absolute', right: '10px', top: '5px' }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          {vkycStatus?.VKYC_STATUS === 'PENDING' ? (
            <>
              <DialogContent dividers>
                <Typography variant="body1" textAlign="center">
                  {t('Your vKYC is still pending Please wait or reschedule')}
                </Typography>
              </DialogContent>
              <DialogActions
                disableSpacing={false}
                className="popupAction"
                style={{ padding: '15px' }}
              >
                <Box
                  className="mainBtn"
                  variant="button"
                  color="secondry"
                  onClick={() => {
                    leaveChannel(audioTrack, videoTrack); // leave all input audio and video when leave
                    setOpenDialogThanks(false); // dialog false
                    setOpenloader(true);
                    setTimeout(() => {
                      navigate('/in/schedule-vkyc'); // redirect at home page
                      setOpenloader(false);
                    }, 500);
                  }}
                >
                  {t('Reschedule')}
                </Box>
                <Box
                  // onClick={() => {
                  //   setOpenDialogThanks(false); // dialog false
                  // }}
                  variant="button"
                  className="mainBtn"
                  color="primary"
                  onClick={() => {
                    leaveChannel(audioTrack, videoTrack); // leave all input audio and video when leave
                    setOpenDialogThanks(false); // dialog false
                    setOpenloader(true);
                    setTimeout(() => {
                      navigate('/in/selfregistration'); // redirect at home page
                      setOpenloader(false);
                    }, 500);
                  }}
                >
                  {t('Close')}
                </Box>
              </DialogActions>
            </>
          ) : (
            <>
              <DialogContent dividers>
                <Typography variant="h5" textAlign="center" mb={2} style={{ color: 'green' }}>
                  {t('Thank you')}
                </Typography>
                <Typography variant="body1" textAlign="center">
                  {t('Your application has been submitted')}
                </Typography>
              </DialogContent>
              <DialogActions
                disableSpacing={false}
                className="popupAction"
                style={{ padding: '15px' }}
              >
                <Box
                  className="mainBtn"
                  variant="button"
                  color="primary"
                  onClick={() => {
                    leaveChannel(audioTrack, videoTrack); // leave all input audio and video when leave
                    setOpenDialogThanks(false); // dialog false
                    setOpenloader(true);
                    setTimeout(() => {
                      navigate('/in/selfregistration'); // redirect at home page
                      setOpenloader(false);
                    }, 500);
                  }}
                >
                  {t('Done')}
                </Box>
              </DialogActions>
            </>
          )}
        </Dialog>
      </Container>
    </>
  );
};

export default VideoKYC;

// function getDecrypt(pageCodeBytes5) {
//   let userIdToken = '';
//   try {
//     const str = pageCodeBytes5.toString(CryptoJS.enc.Utf8);
//     console.log('str', str);
//     if (str.length > 0) {
//       userIdToken = pageCodeBytes5.toString(CryptoJS.enc.Utf8);
//     } else {
//       userIdToken = '';
//     }
//     console.log('not erroe res', userIdToken);
//   } catch (e) {
//     console.log('isError', e);
//     try {
//       const str = pageCodeBytes5.toString(CryptoJS.enc.Hex);
//       if (str.length > 0) {
//         userIdToken = pageCodeBytes5.toString(CryptoJS.enc.Hex);
//       } else {
//         userIdToken = '';
//       }
//       console.log('not erroe res', userIdToken);
//     } catch (e) {
//       console.log('isError 2', e);
//       userIdToken = '';
//     }
//     userIdToken = '';
//   }
//   return userIdToken;
// }
